export default {
  install (Vue) {
    Object.defineProperty(
      Vue.prototype,
      '$mousetrap',
      { value: require('mousetrap') }
    )
  }
}
